module.exports = __webpack_public_path__ + "media/images/top-parts-02-12e33c365a120cff33352e958900de06.jpg";